import { render, staticRenderFns } from "./horizontal-diff.vue?vue&type=template&id=715ec1d3&"
import script from "./horizontal-diff.vue?vue&type=script&lang=js&"
export * from "./horizontal-diff.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-diff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports